import axios, { RawAxiosRequestHeaders } from 'axios'
import { authTokenService } from '../../localStorage/accessToken'
import { Api } from '../generated/client'
import { useAuth } from '../../context/AuthContext'

export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? 'https://api.gug.ge'

const getApiDefaultHeaders = (): RawAxiosRequestHeaders => {
  const token = authTokenService.get()
  return {
    'Access-Control-Allow-Origin': BASE_URL,
    Vary: 'Origin',
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
}

export const apiClient = new Api({
  baseURL: BASE_URL,
  headers: getApiDefaultHeaders()
})

export const reloadHeaders = () => {
  // @ts-expect-error
  apiClient.instance.defaults.headers = {
    ...apiClient.instance.defaults.headers,
    ...getApiDefaultHeaders()
  }
}

export const useApi = () => {
  const handleApiError = (error: unknown) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      window.location.href = '/login'
      return
    }

    let errorMessage = 'Something went wrong. Please try again.'
    if (
      axios.isAxiosError(error) &&
      error.response?.data?.message &&
      Array.isArray(error.response.data.message)
    ) {
      errorMessage = error.response.data.message[0]?.message || errorMessage
    }

    console.error('API error:', error)
    alert(errorMessage.toUpperCase())
  }

  const withErrorHandling = async <T>(
    operation: () => Promise<T>
  ): Promise<T | undefined> => {
    try {
      return await operation()
    } catch (error) {
      handleApiError(error)
      return undefined
    }
  }

  return { withErrorHandling }
}

export const createErrorHandler = (logout: () => void) => (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status

    switch (status) {
      case 401:
        authTokenService.remove()
        reloadHeaders()
        logout()
        return
      case 403:
        alert("Yout don't have permission to perform this action.")
        break
      default:
        alert('Something went wrong. Try again.')
    }
  }
  console.error('Unhandled API error:', error)
}

export const useHandleApiError = () => {
  const { logout } = useAuth()
  return createErrorHandler(logout)
}
